// File: src/components/impact/SustainabilityGoals.js
import React from 'react';
import styles from './SustainabilityGoals.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

function SustainabilityGoals() {
  return (
    <section className={cn('section', styles.section)}>
      <div className="site-container">
        <ScrollAnimation>
          <h2 className={styles.heading}>Our Sustainability Roadmap</h2>
          <p className={styles.subheading}>
            A clear path to diverting 1 million tonnes of organic waste from landfills by 2030.
          </p>
        </ScrollAnimation>
        <div className={styles.roadmap}>
          <div className={styles.line} aria-hidden="true" />

          <ScrollAnimation delay={0}>
            <div id="technology-validated" className={cn(styles.milestone, styles.completed)}>
              <div className={styles.dot}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3 7l3 3 5-6" stroke="var(--color-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className={styles.milestoneContent}>
                <span className={styles.year}>2024</span>
                <h3 className={styles.milestoneTitle}>Technology Validated</h3>
                <p className={styles.milestoneDesc}>Patented process proven at pilot scale.</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation delay={200}>
            <div id="first-commercial-deployment" className={cn(styles.milestone, styles.completed)}>
              <div className={styles.dot}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3 7l3 3 5-6" stroke="var(--color-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className={styles.milestoneContent}>
                <span className={styles.year}>2026</span>
                <h3 className={styles.milestoneTitle}>First Commercial Deployment</h3>
                <p className={styles.milestoneDesc}>Operational facility processing organic waste.</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation delay={400}>
            <div id="scale-nationally" className={styles.milestone}>
              <div className={styles.dot} />
              <div className={styles.milestoneContent}>
                <span className={styles.year}>2028</span>
                <h3 className={styles.milestoneTitle}>Scale Nationally</h3>
                <p className={styles.milestoneDesc}>Multiple facilities across Canada.</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation delay={600}>
            <div id="1m-tonnes-diverted" className={styles.milestone}>
              <div className={styles.dot} />
              <div className={styles.milestoneContent}>
                <span className={styles.year}>2035</span>
                <h3 className={styles.milestoneTitle}>500,000 Tonnes Diverted Annually</h3>
                <p className={styles.milestoneDesc}>Diverts 500,000 tonnes of organic waste from landfills annually.</p>
              </div>
            </div>
          </ScrollAnimation>

        </div>
      </div>
    </section>
  );
}

export default SustainabilityGoals;